module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm._close),
      expression: "_close"
    }],
    class: _vm.classes
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._toggle
    }
  }, [(_vm.icon) ? _c('fa', {
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('i', {
    class: {
      'fa': true, 'fa-angle-down': !_vm.dropup, 'fa-angle-up': !!_vm.dropup
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.open) ? _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": _vm._close
    }
  }, [_vm._t("default")], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7007a597"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/navbar-nav-dropdown.vue
// module id = 703
// module chunks = 85